import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError, Observable } from 'rxjs';

import { BasedataService } from '../shared/basedata.service';

import {Field, FieldMinimal, Fields} from './field';
import { ConfigService } from '@docma-mm-core/config/config.service';
import {Layout} from "@docma-mm-core/layout/layout";
import {map} from "rxjs/operators";

const savedProjectFieldsKey: string = 'mm-savedProjectFields';

@Injectable()
export class FieldService extends BasedataService {

  private projectUrl: string = '/projects/';
  private fieldUrl: string = '/fields';
  private configurationFieldUrl: string = '/configuration/fields';

  groupFields = ['AttributeGroup_Image','ResponsibleCO_Company','ResponsibleCT_Company','ResponsibleSC_Company'];

  constructor(private http: HttpClient, configService: ConfigService) {
    super(configService);
  }

  private getProjectFieldUrl(projectId: number) {
    return super.getFullUrl(this.projectUrl + projectId + this.fieldUrl);
  }

  private getFieldUrl() {
    return super.getFullUrl(this.fieldUrl);
  }


  private getProjectConfigurationFieldUrl(projectId: number) {
    return super.getFullUrl(this.projectUrl + projectId + this.configurationFieldUrl);
  }


  // getFields(top: number = 10, skip: number = 0, tfec: boolean = true): Observable<Fields> {
  //   const endpoint = this.getFieldUrl();
  //   let httpParams = new HttpParams();
  //   if (top) {
  //     httpParams = httpParams.set('$top', top.toString());
  //   }
  //   if (skip) {
  //     httpParams = httpParams.set('$skip', skip.toString());
  //   }
  //   if (tfec) {
  //     httpParams = httpParams.set('tfec', tfec ? 'true' : 'false');
  //   }
  //   return this.http
  //     .get<Fields>(endpoint, { headers: this.getHeaders(), params: httpParams })
  //     .pipe(catchError(e  => this.handleError(e)));
  // }

  getProjectFields(projectId: number, loadGroupFields: boolean = false, groupFields: String[] = [], includedFields: String[] = [], top: number = 10, skip: number = 0, tfec: boolean = true): Observable<Fields> {
    const endpoint = this.getProjectFieldUrl(projectId);
    let httpParams = new HttpParams();
    if (top) {
      httpParams = httpParams.set('$top', top.toString());
    }
    if (skip) {
      httpParams = httpParams.set('$skip', skip.toString());
    }
    if (tfec) {
      httpParams = httpParams.set('tfec', tfec ? 'true' : 'false');
    }
    if(loadGroupFields)
      httpParams = httpParams.set('LoadGroupFields', loadGroupFields ? 'true' : 'false');

    if(groupFields && groupFields.length > 0)
      httpParams = httpParams.set('GroupFields', groupFields.toString());

    if(includedFields && includedFields.length > 0)
      httpParams = httpParams.set('IncludeFields', includedFields.toString());

    return this.http
      .get<Fields>(endpoint, { headers: this.getHeaders(), params: httpParams })
      .pipe(catchError(e  => this.handleError(e)));
  }

  getConfigurationProjectFields(projectId: number): Observable<FieldMinimal[]> {
    const endpoint = `${this.getProjectConfigurationFieldUrl(projectId)}`;
    let httpParams = new HttpParams();
    httpParams = httpParams.set('$top', '10000');
    httpParams = httpParams.set('$skip', '0');
    httpParams = httpParams.set('$details', '10');

    return this.http
      .get<{Data: {Id: number, Field: Field, Name: string}[], Count: number}>(endpoint, { headers: this.getHeaders(), params: httpParams })
      .pipe(map(x =>
        x.Data.map(f => new FieldMinimal(({
          Id: f.Field.Id.toString(),  //(f.Field?.Id ?
          Global: f.Field.GlobalName,
          Project: (f.Id !== -1 && f.Name ? f.Name : f.Field.GlobalName),
          Prop: f.Field.DefaultName,
          DefaultWidth: f.Field.DefaultWidth }))) ))
      .pipe(catchError(e  => this.handleError(e)));

    // f.Field.Id, f.Field.GlobalName, (f.Name ?? f.Field.GlobalName), , f.Field.DefaultName
  }



}
